function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/editableui/editableuiview
 */
import View from '../view';
/**
 * The editable UI view class.
 *
 * @extends module:ui/view~View
 */

var EditableUIView = /*#__PURE__*/function (_View) {
  _inherits(EditableUIView, _View);

  var _super = _createSuper(EditableUIView);

  /**
   * Creates an instance of EditableUIView class.
   *
   * @param {module:utils/locale~Locale} [locale] The locale instance.
   * @param {module:engine/view/view~View} editingView The editing view instance the editable is related to.
   * @param {HTMLElement} [editableElement] The editable element. If not specified, this view
   * should create it. Otherwise, the existing element should be used.
   */
  function EditableUIView(locale, editingView, editableElement) {
    var _this;

    _classCallCheck(this, EditableUIView);

    _this = _super.call(this, locale);

    _this.setTemplate({
      tag: 'div',
      attributes: {
        "class": ['ck', 'ck-content', 'ck-editor__editable', 'ck-rounded-corners'],
        lang: locale.contentLanguage,
        dir: locale.contentLanguageDirection
      }
    });
    /**
     * The name of the editable UI view.
     *
     * @member {String} #name
     */


    _this.name = null;
    /**
     * Controls whether the editable is focused, i.e. the user is typing in it.
     *
     * @observable
     * @member {Boolean} #isFocused
     */

    _this.set('isFocused', false);
    /**
     * The element which is the main editable element (usually the one with `contentEditable="true"`).
     *
     * @private
     * @member {HTMLElement} #_editableElement
     */


    _this._editableElement = editableElement;
    /**
     * Whether an external {@link #_editableElement} was passed into the constructor, which also means
     * the view will not render its {@link #template}.
     *
     * @private
     * @member {Boolean} #_hasExternalElement
     */

    _this._hasExternalElement = !!_this._editableElement;
    /**
     * The editing view instance the editable is related to. Editable uses the editing
     * view to dynamically modify its certain DOM attributes after {@link #render rendering}.
     *
     * **Note**: The DOM attributes are performed by the editing view and not UI
     * {@link module:ui/view~View#bindTemplate template bindings} because once rendered,
     * the editable DOM element must remain under the full control of the engine to work properly.
     *
     * @protected
     * @member {module:engine/view/view~View} #isFocused
     */

    _this._editingView = editingView;
    return _this;
  }
  /**
   * Renders the view by either applying the {@link #template} to the existing
   * {@link #_editableElement} or assigning {@link #element} as {@link #_editableElement}.
   */


  _createClass(EditableUIView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(EditableUIView.prototype), "render", this).call(this);

      if (this._hasExternalElement) {
        this.template.apply(this.element = this._editableElement);
      } else {
        this._editableElement = this.element;
      }

      this.on('change:isFocused', function () {
        return _this2._updateIsFocusedClasses();
      });

      this._updateIsFocusedClasses();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this._hasExternalElement) {
        this.template.revert(this._editableElement);
      }

      _get(_getPrototypeOf(EditableUIView.prototype), "destroy", this).call(this);
    }
    /**
     * Updates the `ck-focused` and `ck-blurred` CSS classes on the {@link #element} according to
     * the {@link #isFocused} property value using the {@link #_editingView editing view} API.
     *
     * @private
     */

  }, {
    key: "_updateIsFocusedClasses",
    value: function _updateIsFocusedClasses() {
      var editingView = this._editingView;

      if (editingView.isRenderingInProgress) {
        updateAfterRender(this);
      } else {
        update(this);
      }

      function update(view) {
        editingView.change(function (writer) {
          var viewRoot = editingView.document.getRoot(view.name);
          writer.addClass(view.isFocused ? 'ck-focused' : 'ck-blurred', viewRoot);
          writer.removeClass(view.isFocused ? 'ck-blurred' : 'ck-focused', viewRoot);
        });
      } // In a case of a multi-root editor, a callback will be attached more than once (one callback for each root).
      // While executing one callback the `isRenderingInProgress` observable is changing what causes executing another
      // callback and render is called inside the already pending render.
      // We need to be sure that callback is executed only when the value has changed from `true` to `false`.
      // See https://github.com/ckeditor/ckeditor5/issues/1676.


      function updateAfterRender(view) {
        editingView.once('change:isRenderingInProgress', function (evt, name, value) {
          if (!value) {
            update(view);
          } else {
            updateAfterRender(view);
          }
        });
      }
    }
  }]);

  return EditableUIView;
}(View);

export { EditableUIView as default };